import { AutonomousSystemNumbersSubscription } from "../../graphql/generated/operations";

export const formatter = (
  /** @type {AutonomousSystemNumbersSubscription | undefined} */ data
) => data?.autonomousSystems.map(({ number }) => number);
